import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import { ActivityControllerUIClient, CreateFlow } from '../../backend/backendapi';

Vue.use(Toasted, { duration: 2000 });

@Component(
    {
        name: 'FlowModal',
        components: {
        }
    })
export default class FlowModal extends Vue {
    //data
    @Prop({ required: true })
    private modalId!: string;
    @Prop({ required: true })
    private createFlow!: CreateFlow;

    //api
    private readonly activityAPI = initClient(ActivityControllerUIClient);

    openModal(): void {
        $('#' + this.modalId).modal('show');
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    //events
    private onFlowClicked(): void {// set needed values for modal dialog
        this.activityAPI.addFlow(this.createFlow);//TODO seperate modal
    }
}
